import { combineReducers } from 'redux';
import { reducer as attach } from './attachModule';
import { reducer as detach } from './detachModule';
import { reducer as resize } from './resizeModule';

export default combineReducers({
	attach,
	detach,
	resize,
});
